<template>
  <svg
    id="ig_icon"
    version="1.1"
    class="social-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 560 560"
    :width="width"
    xml:space="preserve">
    <circle
      :fill="color"
      cx="389.7"
      cy="169.3"
      r="25" />
    <path
      :fill="color"
      d="M279,72.6c-56.3,0-63.4,0.2-85.5,1.3c-22.1,1-37.2,4.5-50.4,9.6c-13.6,
      5.3-25.2,12.4-36.8,23.9c-11.5,11.5-18.6,23.1-23.9,36.7c-5.1,13.2-8.6,
      28.3-9.6,50.4c-1,22.1-1.2,29.2-1.2,85.5s0.3,63.4,1.3,85.5c1,22.1,
      4.5,37.2,9.6,50.4c5.3,13.6,12.4,25.2,23.9,36.8c11.5,11.5,23.1,18.6,
      36.7,23.9c13.2,5.1,28.3,8.6,50.4,9.6c22.1,1,29.2,1.3,85.5,1.3c56.3,
      0,63.4-0.2,85.5-1.3c22.1-1,37.2-4.5,50.4-9.6c13.6-5.3,25.2-12.4,
      36.7-23.9c11.5-11.5,18.6-23.1,23.9-36.7c5.1-13.2,
      8.6-28.3,9.6-50.4c1-22.1,1.3-29.2,
      1.3-85.5s-0.3-63.4-1.3-85.5c-1-22.1-4.5-37.2-9.6-50.4c-5.3-13.6-12.4
      -25.2-23.9-36.8c-11.5-11.5-23.1-18.6-36.7-23.9c-13.2-5.1-28.3-8.6-50.4-9.6
      C342.3,72.8,335.3,72.6,279,72.6L279,72.6z
      M260.4,109.9c5.5,0,11.7,0,18.6,0c55.4,0,62,0.2,83.8,1.2c20.2,0.9,31.2,
      4.3,38.5,7.1c9.7,3.8,16.6,8.3,23.8,15.5c7.3,7.3,11.8,14.2,15.5,
      23.9c2.8,7.3,6.2,18.3,7.1,38.5c1,21.9,1.2,28.4,1.2,83.8s-0.2,
      61.9-1.2,83.8c-0.9,20.2-4.3,31.2-7.1,38.5c-3.8,9.7-8.3,16.6-15.5,
      23.8c-7.3,7.3-14.2,11.8-23.8,15.5c-7.3,2.9-18.3,6.2-38.5,7.1c-21.9,
      1-28.4,1.2-83.8,1.2c-55.4,0-62-0.2-83.8-1.2c-20.2-0.9-31.2-4.3-38.5
      -7.2c-9.7-3.8-16.6-8.3-23.9-15.5c-7.3-7.3-11.8-14.2-15.5-23.8c-2.8-7.3
      -6.2-18.3-7.1-38.5c-1-21.9-1.2-28.4-1.2-83.8s0.2-61.9,1.2-83.8c0.9-20.2,
      4.3-31.2,7.1-38.5c3.8-9.7,8.3-16.6,15.5-23.9c7.3-7.3,14.2-11.8,
      23.9-15.5c7.3-2.9,18.3-6.2,38.5-7.2
      C214.3,110.2,221.7,109.9,260.4,109.9L260.4,109.9z
      M279,173.5c-58.8,0-106.5,47.7-106.5,106.5S220.1,386.5,279,386.5c58.8,0,
      106.5-47.7,106.5-106.5S337.8,173.5,279,173.5L279,173.5z
      M279,210.9c38.2,0,69.2,31,69.2,69.2c0,38.2-31,69.2-69.2,69.2c-38.2,
      0-69.2-31-69.2-69.2C209.8,241.8,240.8,210.9,279,210.9z" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 40,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
